module.exports = __webpack_public_path__ + "img/myneofintech_blanco_old.627196d6.png";